import { Link } from "react-router-dom";
import { FaChevronRight } from "react-icons/fa";
import servicesData from "../services.json";
import contentConfig from "../content.config.json";

import "../Styles/Services.css";

const Services = () => {
  const categories = Object.keys(servicesData);

  return (
    <div className="services-page">
      <div className="banner">
        <div className="banner-overlay">{contentConfig.services.title}</div>
      </div>

      <div className="services-container">
        <div className="services-intro">
          <p>{contentConfig.services.subtitle}</p>
        </div>

        <div className="services-categories">
          {categories.map((category, index) => (
            <div key={index} className="service-category-section">
              <div className="category-header">
                <h2 className="category-title">{category}</h2>
                <div className="category-line"></div>
              </div>

              <div className="services-grid">
                {servicesData[category].map((service) => {
                  if (service.details) {
                    return (
                      <Link
                        key={service.slug}
                        to={`/services/${service.slug}`}
                        className="service-card service-card--clickable"
                      >
                        <span className="service-name">{service.name}</span>
                        <FaChevronRight className="service-arrow" />
                      </Link>
                    );
                  }

                  return (
                    <div key={service.slug} className="service-card">
                      <span className="service-name">{service.name}</span>
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Services;